import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { connect, useDispatch } from 'react-redux';
import ErrorMessage from '../../common/ErrorMessage';
import {
  resetErrors,
  setNextPage,
  setPrevPage,
  showErrors,
} from '../../../redux/slices/appStateSlice';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';

const SubmitButton = ({
  fields,
  params,
  hasError,
  onClick,
  displayErrors,
  errorMessage,
  nextPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
      return;
    }

    if (hasError) {
      dispatch(showErrors());
      return false;
    }

    if (fields.submitButtonDispatchType?.value) {
      let payload = null;

      try {
        if (fields.submitButtonDispatchPayload?.value) {
          payload = JSON.parse(fields.submitButtonDispatchPayload.value);
        }
      } catch {
        payload = fields.submitButtonDispatchPayload.value;
      }

      dispatch({
        type: fields.submitButtonDispatchType.value,
        payload,
      });
    }

    dispatch(resetErrors());
    dispatch(setNextPage(null));
    dispatch(setPrevPage(null));

    if (typeof nextPage === 'string') {
      navigate(nextPage);
    }
  };

  const getClassName = () => {
    let classNames = ['vds-button', 'vds-button--fluid-mobile'];

    if (hasError) {
      classNames.push('vds-button--disabled');
    }
    if (params?.topSpacing) {
      classNames.push(`vds-margin-top-spacing-${params.topSpacing}`);
    }
    if (params?.secondary) {
      classNames.push('vds-button--line');
    }

    return classNames.join(' ');
  };

  return (
    <div className="vds-form__group btn-size">
      <div
        className={`${params?.secondary ? '' : 'vds-centered'} ${
          params?.bottomSpacing ? `vds-margin-bottom-spacing-${params.bottomSpacing}` : ''
        }`}
        data-testid={fields.testid?.value}
      >
        <ErrorMessage displayErrors={displayErrors} errorMessage={errorMessage} params={params} />

        <Text
          tag="button"
          className={getClassName()}
          type="button"
          field={fields.text}
          onClick={handleClick}
          data-testid={`${fields.testid?.value}-cta`}
          style={{ cursor: 'pointer', pointerEvents: 'unset' }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  ...props,
  hasError: props.hasError !== undefined ? props.hasError : state.appState?.hasError,
  nextPage: state.appState?.nextPage,
});

export default connect(mapStateToProps)(SubmitButton);
